import {DataTestAttrs, getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ErrorListProps {
  dataTestAttrs?: DataTestAttrs;
  errors?: Array<string> | null;
  errorMessage?: string | null;
}

const ErrorList = ({dataTestAttrs, errors, errorMessage}: ErrorListProps): JSX.Element | null => {
  if (!errors && !errorMessage) {
    return null;
  } else {
    return (
      <div {...getTestProps(dataTestAttrs)}>
        <BenchlingIcon icon="error" className="u-danger-color u-tiny-spacing-right" />
        {errorMessage}
        {errors && (
          <ul>
            {errors.map((error, i) => (
              <li key={i}>{error}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }
};

export default ErrorList;
